import { Color } from '@solid/shared/styles/colors';
import { Button } from '@solid/shared/ui';
import styled from 'styled-components';

export const ButtonBack = styled(Button)`
  color: ${Color.Blue_500_Primary};
`;
